import React                            from 'react';



         
// import * as Scroll from 'react-scroll';
import  "./ListWrapper.scss";








import ScrollToBottom from 'react-scroll-to-bottom';



export default class ListWrapper extends React.Component {
  render() {
    return <ScrollToBottom className={"scc-ListWrapper" } followButtonClassName="scc-SwivlFollowButton">
       <React.Fragment>{this.props.children} </React.Fragment>
  </ScrollToBottom>;
  }
}